const STATUS_MAP = {
  awaiting_packaging: { label: 'Paketleme Bekliyor', cls: 'bg-yellow-100 text-yellow-800' },
  awaiting_deliver:   { label: 'Teslim Bekliyor',    cls: 'bg-blue-100 text-blue-800' },
  awaiting_supply:    { label: 'Tedarik Bekliyor',   cls: 'bg-rose-100 text-rose-800' },
  delivering:         { label: 'Kargoda',             cls: 'bg-indigo-100 text-indigo-800' },
  delivered:          { label: 'Teslim Edildi',       cls: 'bg-green-100 text-green-800' },
  cancelled:          { label: 'İptal',               cls: 'bg-red-100 text-red-800' },
};

export default function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${s.cls}`}>
      {s.label}
    </span>
  );
}
